import GlobalMixin from './global';

export default {
    mixins: [
        GlobalMixin,
    ],
    data() {
        return {
            pageID: null,
            idPanel: null,
        }
    },
    computed: {
        moduleInternalCode() {},
        moduleCode() {
            return this.moduleInternalCode;
        },
        subModuleCode() {
            return null;
        },
        applicationCode() {
            return this.$store.getters.applicationCode;
        },
        panelId(){
            return this.pageID || this.idPanel;
        },
        panel(){
            return this.panelId ? this.$store.getters.getPanel(this.moduleCode, this.panelId) : {};
        },
        acl(){
            return this.panelId ? this.$store.getters.getAcl(this.moduleCode, this.panelId) : {};
        },
        url(){
            return this.panelId ? this.$store.getters.getUrl(this.moduleCode, this.panelId) : {};
        },
        isPanelActive(){
            return this.panelId ? this.$store.getters.isPanelActive(this.moduleCode, this.panelId) : false;
        },
        isPanelVisible(){
            return this.panelId ? this.$store.getters.isPanelVisible(this.moduleCode, this.panelId) : false;
        },
    },
    methods: {
        closeAllPanels: function() {
            let moduleCode = this.moduleInternalCode;
            if(moduleCode){
                if(this.$store.hasModule(moduleCode)){
                    this.$store.dispatch(`${moduleCode}/closeAllPanels`);
                }
            }
        },
    },
};
